
export const homeObjOne = {
    id:"about",
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: "Premium Bank",
    headLine:"Unlimited Transactions with zero fees",
    description: "Get access to our exclusive app that allows you to send unlimited transactions without getting charged any fees.",
    buttonLabel:"Get started",
    imgStart: false,
    img:require('../../images/svg-1.svg'),
    alt: "Car",
    dark: true,
    primary: true,
    darkText: false
};
export const homeObjTwo = {
    id:"discover",
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: "Unlimited Access",
    headLine:"Login to your account at any time",
    description: "Get access to our exclusive app that allows you to send unlimited transactions without getting charged any fees.",
    buttonLabel:"Learn more",
    imgStart: true,
    img: require("../../images/svg-2.svg"),
    alt: "Piggybank",
    dark: false,
    primary: false,
    darkText: true
};
export const homeObjThree = {
    id:"signup",
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: "Join Our Team",
    headLine:"Create an account is extremely easy",
    description: "Get access to our exclusive app that allows you to send unlimited transactions without getting charged any fees.",
    buttonLabel:"Start Now",
    imgStart: false,
    img: require("../../images/svg-3.svg"),
    alt: "Paper",
    dark: false,
    primary: false,
    darkText: true
};
